import * as React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import Divider from '@material-ui/core/Divider';
import PrimaryNav from './PrimaryNav';
import Logo from './Logo';
import { primaryLinks } from './helpers';
import { styles } from './Sidebar.styles';
import LayoutStyles from '../../styles/layout';
import combineStyles from '../../utils/combineStyles';
import { AppContext } from '../../AppProvider';
import { AppConsumer } from '../../AppProvider';
import { withRouter } from 'react-router-dom';
import { theme } from '../../components/Theme';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import _get from 'lodash/get';

export class Sidebar extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired
  };
  state = {
    open: true,
    persistOpen: true
  };

  toggleDrawerState = () => {
    const { persistOpen } = this.state;

    if (persistOpen) {
      this.setState({ persistOpen: false, open: false });
    } else {
      this.setState({ persistOpen: true });
    }
  };
  menuHoverOut = () => {
    const { open, persistOpen } = this.state;
    if (open && !persistOpen) {
      this.setState({ open: false });
    }
  };
  menuHoverIn = () => {
    const { open } = this.state;
    if (!open) {
      this.setState({ open: true });
    }
  };

  render() {
    const { classes, location } = this.props;
    const { open, persistOpen } = this.state;
    const currentPath = location.pathname;
    const { currentOrgId } = this.context.globalProps;
    const {
      majorLogoUrl,
      minorLogoUrl,
      navigationColor,
      navigationHoverColor,
      navigationActiveColor,
      poweredByUrl
    } = this.context.globalProps.branding;
    // Styling that should only affect the Navigation Sidebar
    const brandedTheme = createMuiTheme({
      ...theme,
      overrides: {
        MuiDrawer: {
          paper: {
            backgroundColor: navigationColor
          }
        },
        MuiListItem: {
          root: {
            '&$selected': {
              backgroundColor: navigationActiveColor,
              '&:hover': {
                backgroundColor: navigationActiveColor
              }
            }
          },
          button: {
            '&:hover': {
              backgroundColor: `${navigationHoverColor} !important`
            }
          }
        }
      }
    });
    // Only show the Powered By section if the Branding has a PoweredByUrl defined
    let poweredByContent = null;
    if (poweredByUrl) {
      if (open) {
        poweredByContent = (
          <div className={classes.poweredBy}>
            Powered by{' '}
            <a href={poweredByUrl} target="_blank" rel="noopener noreferrer">
              Propel
            </a>
          </div>
        );
      } else {
        poweredByContent = <div className={classes.poweredByIcon} />;
      }
    }

    return (
      <MuiThemeProvider theme={brandedTheme}>
        <AppConsumer>
          {({ showSidebar }) => (
            <Drawer
              variant="permanent"
              onMouseEnter={this.menuHoverIn}
              onMouseLeave={this.menuHoverOut}
              className={classNames(classes.drawer, {
                [classes.drawerOpen]: open,
                [classes.drawerClose]: !open,
                [classes.hidden]: !showSidebar
              })}
              classes={{
                paper: classNames({
                  [classes.drawerOpen]: open,
                  [classes.drawerClose]: !open
                })
              }}
              open={open}
            >
              <Logo
                classes={classes}
                open={open}
                persistOpen={persistOpen}
                menuToggle={this.toggleDrawerState}
                majorLogoUrl={majorLogoUrl}
                minorLogoUrl={minorLogoUrl}
              />
              <Divider classes={{ root: classes.divider }} />
              <div className={classes.nav}>
                <div className={classes.navContainer}>
                  <PrimaryNav
                    links={primaryLinks.map(link => {
                      return {
                        ...link,
                        requiresOrg: _get(link, 'requiresOrg', true),
                        isPermitted: _get(link, 'isPermitted', () => {
                          return true;
                        })
                      };
                    })}
                    classes={classes}
                    open={open}
                    currentPath={currentPath}
                    currentOrgId={currentOrgId}
                    globalProps={this.context.globalProps}
                  />
                </div>
              </div>
              {poweredByContent}
            </Drawer>
          )}
        </AppConsumer>
      </MuiThemeProvider>
    );
  }
}

Sidebar.contextType = AppContext;
export default withRouter(
  withStyles(combineStyles(styles, LayoutStyles), {
    withTheme: true
  })(Sidebar)
);
